"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeNoDataRgbaString;
function makeNoDataRgbaString(noDataValue) {
  return `rgba(${noDataValue}, ${noDataValue}, ${noDataValue}, 0)`;
}